export default {
  itens: []
}



// WEBPACK FOOTER //
// ./src/store/modules/image_upload/state.js